import React from 'react';
import { Grid, Autocomplete, TextField, FormControlLabel, Checkbox } from '@mui/material';
import { antibiotics, antiseptics } from '../constants/options';

const AntibioticAndMedications = ({ formData, setFormData, handleChange }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          options={antibiotics}
          value={formData.antibiotic || null}
          onChange={(e, newValue) => setFormData(prev => ({ ...prev, antibiotic: newValue || '' }))}
          renderInput={(params) => <TextField {...params} label="Antibiotic Chosen" />}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="dose"
          type='number'
          label="Dose (minutes before surgery)"
          value={formData.dose || ''}
          onChange={handleChange}
          fullWidth
          inputProps={{ min: 15, max: 120 }}
          helperText="Time in minutes (15-120 min recommended)"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="timeToAdminister"
          label="Time to Administer"
          type="time"
          value={formData.timeToAdminister || ''}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          fullWidth
          helperText="Auto-calculated based on dose timing"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name="additionalAntibiotics"
          label="Additional Antibiotics"
          value={formData.additionalAntibiotics || ''}
          onChange={handleChange}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          options={antiseptics}
          value={formData.skinPrep || null}
          onChange={(e, newValue) => setFormData(prev => ({ ...prev, skinPrep: newValue || '' }))}
          renderInput={(params) => <TextField {...params} label="Skin Prep Type" />}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          name="preAnestheticMeds"
          label="Pre-Anesthetic Medications"
          value={formData.preAnestheticMeds || ''}
          onChange={handleChange}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={<Checkbox name="preOpSedation" checked={formData.preOpSedation} onChange={handleChange} />}
          label="Pre-op Sedation Required"
        />
      </Grid>
    </Grid>
  );
};

export default AntibioticAndMedications;
